// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c9n7","col":"styles_col__1Surk"};